/* Built In Imports */
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import parser from 'html-react-parser';
import forEach from 'lodash/forEach';
import { useCookies } from 'react-cookie';

/* Internal Imports */
/* Components */
// import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import config from '@config';
import { isOpenInNewTab, refineUrlDomain } from '@moms/Utility/utils';

//Styles
import TopBannerSt from '@moms/styleData/TopbannerSt';
/* Services */

/**
 * Returns the Simple Button.
 *
 * @param style.style
 * @param {object} style - Style for button.
 * @param {string} bType - Button Type.
 * @param {string} region - Current User Country.
 * @param {string} language - Current User Language.
 * @param style.bType
 * @param style.region
 * @param style.lang
 * @param style.clickHandler
 * @param style.padding
 * @param style.textAlign
 * @param style.width
 * @param style.mb
 * @param style.mt
 * @param style.fontstyle
 * @param style.fontbold
 * @param style.extraDomains
 * @param style.disabled
 * @param style.pageName
 * @param style.height
 * @returns {ReactElement} SimpleButton component.
 */
export default function SimpleButton({
  style,
  bType,
  region,
  lang,
  clickHandler,
  height,
  padding,
  textAlign,
  width,
  mb,
  mt,
  mx,
  fontstyle,
  fontbold,
  pageName,
  pageConfig,
  disabled = false,
  icon,
  disableButton,
  scrollId,
  hashScroll,
  targetwindow,
  ...props
}) {
  const router = useRouter();
  const [currentUrl, setCurrentUrl] = useState('');
  const cookieParams = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ];
  const [cookies, setCookie] = useCookies(cookieParams);
  // console.log("style",style);

  useEffect(() => {
    // if (!router.isReady) return;
    setCurrentUrl(refineUrlDomain(style?.linkUrl, region, lang));
    // setTimeout(function () {
    forEach(cookieParams, function (cookie) {
      if (router.query[cookie]) {
        setCookie(cookie, router.query[cookie], {
          path: '/',
          maxAge: 3600 * 24, // Expires after 1year
          sameSite: true,
          domain: config.COOKIE_DOMAIN,
          secure: true,
        });
      }
    });
    // }, 0);
  }, [router.isReady, style?.linkUrl]);

  const RenderButton = ({ style }) => {
    const buttonStyle = {
      Orange: (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            display="inline-block"
            mb={mb || '20px'}
            fontFamily="Trirong"
            // fontStyle="italic"
            fontWeight="500"
            borderRadius="5px"
            bgColor="transparent"
            border="solid 1px #cf4520"
            color="#cf4520"
            fontSize="25px"
            padding="20px 29px"
            lineHeight="30px"
            letterSpacing="-0.736px"
            _hover={{
              textDecoration: 'none',
              bgColor: '#cf4520',
              color: 'white',
            }}
            textAlign={textAlign || 'left'}
            width={'auto'}
            h="auto"
            minH="50px"
            // minW="200px"
            m="0 auto"
            onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            {...props}
            sx={{
              i: { ...TopBannerSt?.[lang]?.buttonStI },
              'i:after': {
                content: "''",
                marginRight: '10px',
              },
            }}
          >
            {parser(style?.buttonText)}
          </Link>
        </NextLink>
      ),
      Blue: (
        <NextLink href={disabled ? '#' : currentUrl} passHref legacyBehavior>
          <Link
            display="inline-block"
            mb={mb || '20px'}
            fontFamily="Trirong"
            // fontStyle="italic"
            fontWeight="500"
            borderRadius="5px"
            bgColor="transparent"
            border="solid 1px #cf4520"
            color="#cf4520"
            fontSize="25px"
            padding="20px 29px"
            lineHeight="30px"
            letterSpacing="-0.736px"
            _hover={{
              textDecoration: 'none',
              bgColor: '#cf4520',
              color: 'white',
            }}
            textAlign={textAlign || 'left'}
            width={'auto'}
            h="auto"
            minH="50px"
            // minW="200px"
            m="0 auto"
            onClick={clickHandler}
            target={
              style?.openInNewTab == true
                ? '_blank'
                : isOpenInNewTab(currentUrl)
                ? '_blank'
                : ''
            }
            {...props}
            sx={{
              i: { ...TopBannerSt?.[lang]?.buttonStI },
              'i:after': {
                content: "''",
                marginRight: '10px',
              },
            }}
          >
            {parser(style?.buttonText)}
          </Link>
        </NextLink>
      ),
    };
    return buttonStyle[style?.buttonStyle] || null;
  };

  return (
    <Box
      boxSizing="borderBox"
      display="flex"
      alignItems="center"
      as={'button'}
      color="#faf7f0"
      width={'auto'}
      h={height || 'auto'}
      minH={height || '50px'}
      borderRadius="5px"
      fontSize={'18px'}
      textAlign="center"
      justifyContent="center"
      cursor="default"
      mb={mb || '30px'}
      mt={mt || '12px'}
      mx={mx}
      className={disableButton}
    >
      {currentUrl ? <RenderButton style={style} /> : null}
    </Box>
  );
}
